import { MenuBook } from '@mui/icons-material'

const catalogIndex = {
  icon: MenuBook,
}

export default catalogIndex
